
import { t } from "@/lib/i18n";
export const TIPO = {
  importacion: {
    get label() { return t("IMPORTACIÓN"); },
    color: "#1D5FBF",
    solid: "bg-imp text-white",
    badge: "bg-imp-tint text-imp",
    text: "text-imp",
    ring: "ring-imp",
    border: "border-imp",
  },
  exportacion: {
    get label() { return t("EXPORTACIÓN"); },
    color: "#D5621C",
    solid: "bg-exp text-white",
    badge: "bg-exp-tint text-exp-text",
    text: "text-exp-text",
    ring: "ring-exp",
    border: "border-exp",
  },
};

export const ESTADO = {
  sin_asignar: { get label() { return t("Sin asignar"); }, color: "#7E838C" },
  asignada: { get label() { return t("Asignada"); }, color: "#56657E" },
  en_ruta: { get label() { return t("En ruta"); }, color: "#0B7F8C" },
  movida: { get label() { return t("Movida"); }, color: "#B07A12" },
  entregada: { get label() { return t("Entregada"); }, color: "#277A3F" },
  despachada: { get label() { return t("Despachada"); }, color: "#16181D" },
  // Fix P (2026-10-13): estado nuevo (todas las etapas completadas). Los tres de arriba solo quedan para leer eventos viejos.
  terminada: { get label() { return t("Terminada"); }, color: "#277A3F" },
  cancelada: { get label() { return t("Cancelada"); }, color: "#A0A4AB" },
};

export const MOTIVO_LIBERAR = {
  get problema_mecanico() { return t("Problema mecánico"); },
  get fuera_de_horario() { return t("Fuera de horario"); },
  get cliente_cerrado() { return t("Cliente cerrado"); },
  get otro() { return t("Otro"); },
};

export const MOTIVO_PENDIENTE = {
  get celular_roto() { return t("Celular roto"); },
  get sin_bateria() { return t("Sin batería"); },
  get otro() { return t("Otro"); },
};
// Fix R (2026-10-13): qué documento avisó el chofer que no pudo subir (tipo de documento). «papel» y «registro» son los avisos de antes del sistema de etapas.
export const FALTA_NOMBRE = {
  get signed_pod() { return t("Signed DO / POD"); }, get empty_j1() { return t("Empty return J1"); }, get pickup_receipt() { return t("Pickup receipt"); }, get rail_receipt() { return t("Rail pickup receipt"); },
  get chassis_j1() { return t("Chassis return J1"); }, papel: "papel", registro: "registro",
};
export const faltaNombre = (f) => FALTA_NOMBRE[f] || f;

// Fix P (2026-10-13): tipos de documento que sube la oficina (el Delivery Order lo abre el chofer con «DO · PDF»).
export const TIPO_DOC_OFICINA = {
  get delivery_order() { return t("Delivery Order"); },
  get instrucciones() { return t("Instrucciones"); },
  get otro() { return t("Otro"); },
};

export const INCIDENTE_TIPO = {
  get llanta() { return t("Llanta"); },
  get falla_mecanica() { return t("Falla mecánica"); },
  get accidente() { return t("Accidente"); },
  get otro() { return t("Otro"); },
};

export const ROL_LABEL = {
  get admin() { return t("Administrador"); },
  get dispatch() { return t("Dispatch"); },
  get mantenimiento() { return t("Mantenimiento"); },
  get chofer() { return t("Chofer"); },
};

export const TIPO_UBICACION = {
  get riel() { return t("Riel"); },
  get yarda() { return t("Yarda"); },
  get deposito_vacios() { return t("Depósito de vacíos"); },
  get alquiler_chasis() { return t("Alquiler de chasis"); },
};

export function rutaInicio(user) {
  if (!user) return "/login";
  if (user.rol === "chofer") return "/chofer";
  if (user.rol === "mantenimiento") return "/panel/insumos";
  return "/panel";
}

export const ESTADOS_US = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA",
  "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT",
  "VA", "WA", "WV", "WI", "WY", "DC",
];

export const INSUMO_ESTADO_LABEL = {
  get pendiente() { return t("Pendiente"); },
  get entregado() { return t("Entregado"); },
  get pendiente_aprobacion() { return t("Pendiente de aprobación"); },
  get aprobado() { return t("Aprobado"); },
  get rechazado() { return t("Rechazado"); },
  get registrado() { return t("Registrado"); },
};

export const INSUMO_ESTADO_COLOR = {
  pendiente: "#B07A12",
  entregado: "#277A3F",
  pendiente_aprobacion: "#56657E",
  aprobado: "#0B7F8C",
  rechazado: "#C4312E",
  registrado: "#7E838C",
};
